import api from "../assets/api.png";
import aws from "../assets/aws.png";
import docker from "../assets/docker.png";
import huggingface from "../assets/huggingface.png";
import python from "../assets/python.png";

import email from "../assets/email.png";
import github from "../assets/github.png";
import linkedin from "../assets/linkedin.png";
import mobile from "../assets/mobile.png";

import circle from "../assets/circle.svg";
import logo from "../assets/logo.png";
import profile from "../assets/profile.png";

import contact from "../assets/contact.png";

export default {
	email,
	mobile,
	api,
	huggingface,
	aws,
	profile,
	circle,
	logo,
	python,
	contact,
	linkedin,
	github,
	docker,
};
